import { getIn } from 'seamless-immutable';

export const buyTogether = (data, salesPrice) => {
  const buyTogetherVipEnabled = getIn(data, ['buyTogetherVIP', 'active']);
  const buyTogetherVipPrice = getIn(data, ['buyTogetherVIP', 'price']);

  return buyTogetherVipEnabled ? salesPrice + buyTogetherVipPrice : null;
};
